import React from "react"
import { Grid, Link } from "@mui/material";
import DesktopMenu from "./desktopMenudt.js"
import MobileMenu from "./mobileMenudt.js"

// import './menu.css'

import logod from '../../../images/new-logo.png'
import logo from '../../../images/new-logo.png'

const MenuList = [
    [
        'Dashboard', // title
        '/dashboard', // Link
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'dashboard'
    ],
    [
        'Rewards',
        '/rewards', 
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'store'
    ],
    [
        'NFTS',
        '/nfts', 
        'Global---menu-link hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'store'
    ],
    [
        'Chart',
        '#',
        'Global---menu-link hover px-3 py-2 mb-3 hide_btn', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'candlestick_chart'
    ],
    [
        'Buy Now',
        '#',
        'Global---menu-link hover px-3 py-2 mb-3 hide_btn', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'account_balance_wallet'
    ],
    [
        'Play Now',
        'https://game.metasnooker.io/',
        'MS---Neon--Button btn text-center hover px-3 py-2 mb-3', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        ''
    ]
];

const Menu = () => {
    return(
        <Grid item xs={12} md={2} className="Global-main-menu-outer text-md-center w-100 pb-0 py-md-4 px-0 ">
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logod}
                    menuList={MenuList}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
        </Grid>
    )
}

export default Menu;